export const LINK_TRACK_PROTOCOLS = [
  { text: 'HTTP', value: 'http:', selected: true },
  { text: 'HTTPS', value: 'https:', selected: true },
  { text: 'Mailto', value: 'mailto:', selected: false },
  { text: 'FTP', value: 'ftp:', selected: true },
  { text: 'News', value: 'news:', selected: true },
  { text: 'Tel', value: 'tel:', selected: false }
]
export const TYPE_FILE = 'file'
export const TYPE_URL = 'url'

export const MAX_UPLOAD_SIZE = 20 * 1024 * 1024

export const FILE_ACCEPT = ['.zip', '.html', '.htm']
export const URL_REGEX = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g

export const EXPIRE_IN = 5

export const MIN_ITEMS_IN_DETAILS = 5

export const RESP_WARNING = 'warning'
export const RESP_ERROR = 'error'
export const RESP_SUCCESS = 'success'

export const WARNING_ACTION_PREVIEW = 'P'
export const WARNING_ACTION_EDIT = 'E'

export const RESPONSE_CODE = [
  {
    key: 'ImagesNotFoundWarning',
    code: 0,
    lang_id: 'Load.EmailMessageImport.ImagesNotFoundWarningNew',
    details: true
  },
  {
    key: 'FilesNotAllowedError',
    code: 2,
    lang_id: 'Load.EmailMessageImport.FilesNotAllowedErrorMessageNew',
    details: true
  },
  {
    key: 'HTMLWrongError',
    code: 3,
    lang_id: 'Load.EmailMessageImport.HTMLWrongErrorMessageNew',
    details: false
  },
  {
    key: 'HTMLNotFoundError',
    code: 4,
    lang_id: 'Load.EmailMessageImport.HTMLNotFoundErrorMessageNew',
    details: false
  },
  {
    key: 'GenericError',
    code: 5,
    lang_id: 'Load.EmailMessageImport.GenericErrorMessageNew',
    details: false
  },
  {
    key: 'HTMLMultipleError',
    code: 6,
    lang_id: 'Load.EmailMessageImport.HTMLMultipleErrorNew',
    details: false
  },
  {
    key: 'DocumentNotFoundWarning',
    code: 7,
    lang_id: 'Load.EmailMessageImport.DocumentNotFoundWarningNew',
    details: true
  },
  {
    key: 'DownloadHtmlFromUrlError',
    code: 8,
    lang_id: 'Load.EmailMessageImport.DownloadHtmlFromUrlErrorNew',
    details: false
  },
  {
    key: 'AttachmentsOptionNotEnabledWarningImportCode',
    code: 9,
    lang_id: 'Load.EmailMessageImport.AttachmentsOptionNotEnabledWarning',
    details: true
  },
  {
    key: 'AttachmentsExceededMaxNumberWarningImportCode',
    code: 10,
    lang_id: 'Load.EmailMessageImport.AttachmentsExceededMaxNumberWarning',
    details: true
  },
  {
    key: 'AttachmentsExceededSizeLimitWarningImportCode',
    code: 11,
    lang_id: 'Load.EmailMessageImport.AttachmentsExceededSizeLimitWarning',
    details: true
  }
]
export const getExtension = fileOrUrl => {
  return fileOrUrl
    .split('?')[0]
    .split('.')
    .pop()
}
